import React from "react";
import parse from "../lib/legoParser";
import {
  updateProductByIds,
  updateCombinationByIds,
  updateProdcutBySearch,
  Config,
  UpdateComponetsProtocol,
  DataScheduler,
  IDataRequestType,
  IDataRequest,
} from "../lib/utils";
interface IState {
  content: any;
}

const InitState: IState = {
  content: {},
};




const withContent = (TreeNode, components, OutLine) => {
  return class extends React.PureComponent<any, IState> {
    readonly state: IState = InitState;

    componentDidUpdate(prevProps) {
      if (
        prevProps.tree !== this.props.tree ||
        (prevProps.tree.root && !this.state.content.root)
      ) {
        this.setState({
          content: { ...this.props.tree },
        });
        this.checkComponents(this.props.tree);
      }
    }

    checkComponents = (config: Config) => {
      const components = this.componentsSerialization(config);
      const updateComponetsProtocol = this.getNeedUpdateComponets(
        components,
        config
      );
      const dataScheduler = this.getDataScheduler(
        updateComponetsProtocol,
        config
      );
      this.updateContextHandler(dataScheduler.queue);
    };

    componentsSerialization = (
      data: Record<string, Record<string, any>>
    ): string[] => {
      const componentList: string[] = [];
      this.getComponentChildren("root", data, componentList);
      return componentList;
    };

    getComponentChildren = (
      componet: string,
      data: Record<string, Record<string, any>>,
      list: string[]
    ) => {
      if (componet && data) {
        const componentList = data[componet]?.childrens || [];
        list.push(...componentList);
        componentList.forEach((com) =>
          this.getComponentChildren(com, data, list)
        );
      }
    };

    getPromiseQueue = (iDataList: IDataRequest[]): Promise<any>[] => {
      return iDataList.map((request) => this.getDataSource(request));
    };

    getIDataRequest = (
      idDataQueuse: UpdateComponetsProtocol["queue"][0],
      updateComponetsProtocol: UpdateComponetsProtocol,
      config: Config
    ): IDataRequest | null => {
      const { productByIds, combinationListById } = updateComponetsProtocol;
      switch (idDataQueuse.type) {
        case IDataRequestType.discover:
          return {
            type: IDataRequestType.discover,
            request: {
              component: idDataQueuse.component,
              config,
            },
          };
        case IDataRequestType.product_id:
          return {
            type: IDataRequestType.product_id,
            request: {
              componentIdMaps: productByIds,
              config,
            },
          };
        case IDataRequestType.combination_id:
          return {
            type: IDataRequestType.combination_id,
            request: {
              componentIdMaps: combinationListById,
              config,
            },
          };
        default:
          return null;
      }
    };

    getDataScheduler = (
      updateComponetsProtocol: UpdateComponetsProtocol,
      config: Config
    ): DataScheduler => {
      const { queue } = updateComponetsProtocol;
      return {
        queue: queue.reduce((init, item) => {
          const idData = this.getIDataRequest(
            item,
            updateComponetsProtocol,
            config
          );
          idData && init.push(idData);
          return init;
        }, [] as DataScheduler["queue"]),
      };
    };

    // todo 统一入口 便于后期新增type
    getNeedUpdateComponets = (
      componetList: string[],
      config: Config
    ): UpdateComponetsProtocol => {
      return componetList.reduce(
        (init, item) => {
          const componentConfig = config[item];
          if (item.startsWith("ProductList")) {
            if (
              componentConfig.config &&
              componentConfig.config.parseType === "tag"
            ) {
              init.queue.push({
                type: IDataRequestType.discover,
                component: item,
              });
            } else {
              if (componentConfig?.config?.ids?.length) {
                init.productByIds[item] = componentConfig.config.ids;
                if (init.queue[0]?.type !== IDataRequestType.product_id) {
                  init.queue.unshift({
                    type: IDataRequestType.product_id,
                    component: "",
                  });
                }
              }
            }
          } else if (
            item.startsWith("CombinationList") &&
            componentConfig?.config?.ids?.length
          ) {
            init.combinationListById[item] = componentConfig.config.ids;
            if (init.queue[1]?.type !== IDataRequestType.combination_id) {
              if (init.queue[0]?.type === IDataRequestType.product_id) {
                init.queue.splice(1, 0, {
                  type: IDataRequestType.combination_id,
                  component: "",
                });
              } else {
                init.queue.unshift({
                  type: IDataRequestType.combination_id,
                  component: "",
                });
              }
            }
          }
          return init;
        },
        {
          combinationListById: {},
          productByIds: {},
          queue: [],
        } as UpdateComponetsProtocol
      );
    };

    updateContextHandler = (queue: DataScheduler["queue"]) => {
      if (!queue.length) {
        return;
      }
      Promise.all(this.getPromiseQueue(queue.splice(0, 5))).then((res) => {
        this.updateContext(res);
        this.updateContextHandler(queue);
      });
    };

    updateContext = (res) => {
      const response = Object.assign({}, ...(res || []));
      this.setState({
        content: {
          ...this.state.content,
          ...Object.entries(response).reduce((init, [key, data]) => {
            init[key] = {
              ...(this.state.content[key] || {}),
              config: {
                ...(this.state.content[key]?.config || {}),
                ...((data as Record<string, any>) || {}),
              },
            };
            return init;
          }, {}),
        },
      });
    };

    getDataSource = (idData: IDataRequest): Promise<any> => {
      const handler = this.props.override?.(idData.type);
      const isFunc = typeof handler === "function"
      const { config } = idData.request;
      switch (idData.type) {
        case IDataRequestType.discover:
          return isFunc
            ? handler(idData.request.component, config)
            : updateProdcutBySearch(idData.request.component, config);
        case IDataRequestType.product_id:
          return isFunc
            ? handler(idData.request.componentIdMaps, config)
            : updateProductByIds(idData.request.componentIdMaps, config);
        case IDataRequestType.combination_id:
          return isFunc
            ? handler(idData.request.componentIdMaps, config)
            : updateCombinationByIds(idData.request.componentIdMaps);
      }
    };

    render() {
      const { tree, clickTo } = this.props;
      const { content } = this.state;
      if (!tree) return null;
      const treeData = parse({
        ...content,
      });
      if (treeData && treeData.id) {
        return (
          <TreeNode
            {...treeData}
            components={components}
            OutLine={OutLine}
            clickTo={clickTo}
          ></TreeNode>
        );
      } else {
        return <div></div>;
      }
    }
  };
};

export default withContent;
